export default function(settings, instance) {
    const $elViewReport = $('#viewReport');
    const { elToggle } = settings;
    const $elToggle = $(elToggle);
    const $document = $(document);

    document.addEventListener('click', function(e) {
        const $elTarget = $(e.target);
        const $reportsList = $('.ssrs__reports-list');
        const $reportsFavlist = $('.ssrs__favlist-categroy');

        if (
            ($elTarget.hasClass('k-item') && $reportsList.length) ||
            ($elTarget.hasClass('ssrs__favlist-report-item') && $reportsFavlist.length)
        )
            instance.open($elToggle.filter(`.collapsible-topic__ssrs-params`));
    });

    $document.on('ssrs:ReportBuilt', function(event) {
        if ($elViewReport.length) {
            instance.close($elToggle.filter(`.collapsible-topic__ssrs-params.open`));
            $elViewReport.removeClass('opacity-0').addClass('opacity-100');

            $('#ssrsCloseReport').on('click', function() {
                instance.open($elToggle.filter(`.collapsible-topic__ssrs-params`));
            });
        }
    });
}
